import src from "IMAGE";
export default { src, width: 456, height: 232, blurWidth: 0, blurHeight: 0};
